import React, { useCallback, memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DateTime } from "luxon";

import {
  nextTicketPage,
  prevTicketPage,
  setTicketSort,
} from "../../store/managerTickets/actions";

import PaginationComponent from "../Common/Pagination";
import TableComponent from "../Common/Table";
import AgentInfo from "../Common/agentInfo";
import SlaStatus from "../Common/slaStatus";

import Filter from "./FilterComponent";
import Header from "./Header";
import SpyButton from "./SpyButton";

import "./style.scss";
import { Container } from "reactstrap";

function TicketsOperatorArea() {
  return (
    <div className="page-content">
      <Container fluid>
        <div className="ticket-operator-area">
          <div className="menu">
            <Header />
          </div>

          <div className="table-operator">
            <Table />
          </div>
          <div className="pagination-operator">
            <Pagination />
          </div>

          <Filter />
        </div>
      </Container>
    </div>
  );
}

export default memo(TicketsOperatorArea);

const Pagination = memo(() => {
  const status = useSelector((state) => state.ManagerTickets.status.table);
  const totalItems = useSelector(
    (state) => state.ManagerTickets.tableData?.length
  );
  const dispatch = useDispatch();

  const pagination = useSelector(
    (state) => state.ManagerTickets.pagination
  );

  const handlePrevPage = useCallback(() => {
    if (status.loading) return;

    if (pagination.current > 1) {
      dispatch(prevTicketPage());
    }
  }, [dispatch, pagination, status]);

  const handleNextPage = useCallback(() => {
    if (status.loading) return;
    if (
      pagination.current < Math.ceil(pagination.total / pagination.pageSize)
    ) {
      dispatch(nextTicketPage());
    }
  }, [dispatch, pagination, status]);

  return (
    <PaginationComponent
      currentPage={pagination.current}
      totalItems={totalItems}
      total={pagination.total}
      handlePrevPage={handlePrevPage}
      handleNextPage={handleNextPage}
      loading={status.loading}
      pageSize={pagination.pageSize}
    />
  );
});

const columns = [
  { path: "protocol", label: "Protocol" },
  { path: "client", label: "Client" },
  { path: "document", label: "Document" },
  {
    path: "created_at",
    label: "Create at",
    content: (e) =>
      DateTime.fromJSDate(new Date(e)).toFormat("dd/MM/yyyy HH:mm"),
  },
  {
    path: "status",
    label: "Status",
    content: (type, { sla_time }) => (
      <SlaStatus data={{ type, time: sla_time }} />
    ),
  },
  {
    path: "agent",
    label: "Agent",
    content: (agent, { availability, id,transf_user_id }) => (
      <AgentInfo data={{ agent, availability, id, transf_user_id}} />
    ),
  },
  { path: "skill_name", label: "Skill" },
  { path: "tab", label: "Tab" },
  {
    path: "action",
    label: "Action",
    content: (_, { id, can_spy }) => <SpyButton id={can_spy && id} />,
    fixed: true,
  },
];

const Table = memo(() => {
  const { tableData } = useSelector((state) => state.ManagerTickets);
  const status = useSelector((state) => state.ManagerTickets.status.table);
  const dispatch = useDispatch();

  const handleSort = useCallback(
    (sortColumn) => {
      if (status.loading) return;
      dispatch(setTicketSort(sortColumn));
    },
    [dispatch, status]
  );

  return (
    <TableComponent
      columns={columns}
      rows={tableData}
      onSort={handleSort}
      tableSize={10}
      isLoading={status.loading}
    />
  );
});
